module.exports = __webpack_public_path__ + "img/service1.51e2adeb.png";